export enum PageMode {
  ON = 'ON',
  OFF = 'OFF',
}
